module.exports = __webpack_public_path__ + "static/img/pay_succ_vava.bb1b6aaa.png";